<script>
import CommonTableComponent from "@/components/table.vue";
import DatePicker from "vue2-datepicker";
import constant from "@/configs/constant";

export default {
  name: "regularly_reservation",
  props: {
    isEdit: {
      type: Boolean,
      default: false
    },
    regularlyReservation: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {};
  },
  components: {
    CommonTableComponent,
    DatePicker
  },
  computed: {
    zz_regularly_reservation_intervals() {
      return (
        this.$store.getters["options/options_tables"]
          .zz_regularly_reservation_intervals ?? []
      );
    },
    zz_reservation_status_2() {
      return (
        this.$store.getters["options/options_tables"].zz_reservation_status_2 ??
        []
      );
    },
    days_of_the_week() {
      return constant.DAY_OF_WEEKS;
    }
  },
  methods: {
    disabledDateForEndDate: function(date) {
      return (
        date.setHours(0, 0, 0, 0) <
        new Date(this.regularlyReservation.fromDate).setHours(0, 0, 0, 0)
      );
    },
    updateTransport(id) {
      alert("update transport" + id);
    },
    getNameWasteOrServiceByWorkOrder(workOrder) {
      return workOrder.waste
        ? workOrder.waste.name
        : workOrder.service
        ? workOrder.service.name
        : "";
    },
    getNameCategoryWasteOrServiceByWorkOrder(workOrder) {
      return workOrder.waste
        ? workOrder.waste.waste_category.name_abbreviated
        : workOrder.service
        ? workOrder.service.service_category.name_abbreviated
        : "";
    },
    getVendorSiteOfTreatmentNameMethod(disposalSite) {
      return disposalSite
        ? disposalSite.disposal_site_by_waste_category.vendor_site_of_treatment
            .name_abbreviated +
            "/" +
            disposalSite.disposal_site_by_waste_category.zz_treatment_method
              .treatment_method
        : "";
    },
    removeCarBySchedule(scheduleId) {
      alert("delete car" + scheduleId);
    },
    removeStaffBySchedule(scheduleId) {
      alert("delete staff" + scheduleId);
    }
  }
};
</script>

<template>
  <b-card>
    <div class="mb-3 title-detail">■予約受付内容</div>
    <div class="mb-3 d-flex justify-content-end gap-1">
      <b-button :disabled="!isEdit" variant="primary" size="md" class="me-2">履歴</b-button>
      <b-button :disabled="!isEdit" variant="primary" size="md" type="submit">削除</b-button>
    </div>
    <div class="mb-2 d-flex flex-wrap col-gap-5">
      <div class="d-flex">
        <label for="reservationCode" class="lbl-custom">予約番号：</label>
        <b-form-input
          v-if="isEdit"
          v-model="regularlyReservation.id"
          id="reservationCode"
          type="text"
        />
        <span v-else id="reservationCode">{{ regularlyReservation.id }}</span>
      </div>
      <div class="d-flex flex-wrap">
        <h4>
          <span variant="primary" class="badge bg-primary"
            >車両・従業員設定</span
          >
        </h4>
        <h4>
          <span variant="success" class="badge bg-success ms-1"
            >委託先依頼中</span
          >
        </h4>
        <h4>
          <span variant="info" class="badge bg-info ms-1">キャンセル</span>
        </h4>
      </div>
    </div>
    <div class="mb-1 d-flex col-gap-5">
      <div>
        <span class="lbl-custom">定期予約</span>
      </div>
      <div class="d-flex flex-column">
        <div class="mb-2 d-flex gap-2">
          <div class="d-flex">
            <span class="lbl-custom">開始年月日：</span>
            <div v-if="isEdit">
              <ValidationProvider
                rules="required"
                :custom-messages="{ required: '開始年月日は必須項目です' }"
                v-slot="{ errors, classes }"
              >
                <div :class="classes" class="input-control">
                  <date-picker
                    v-model="regularlyReservation.start_datetime"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    value-type="format"
                    type="date"
                  ></date-picker>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <span v-else
              >{{ regularlyReservation.start_datetime | longDateWithJP }}（土）</span
            >
          </div>
          <div><span>～</span></div>
          <div class="d-flex">
            <span class="lbl-custom ms-2">終了年月日：</span>
            <div v-if="isEdit">
              <ValidationProvider
                rules="required"
                :custom-messages="{ required: '終了年月日は必須項目です' }"
                v-slot="{ errors, classes }"
              >
                <div class="input-control" :class="classes">
                  <date-picker
                    v-model="regularlyReservation.end_datetime"
                    lang="ja"
                    placeholder="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                    type="date"
                    value-type="format"
                    :disabled-date="disabledDateForEndDate"
                  ></date-picker>
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </div>
            <span v-else
              >{{ regularlyReservation.end_datetime | longDateWithJP }}（火）</span
            >
          </div>
        </div>
        <div class="d-flex">
          <label for="timeline" class="lbl-custom">時間帯：</label>
          <div class="d-flex gap-2">
            <date-picker
              v-if="isEdit"
              v-model="regularlyReservation.timeStart"
              lang="ja"
              type="time"
              placeholder="hh:mm"
              format="hh:mm"
              value-type="format"
            ></date-picker>
            <span v-else>
              {{
                this.$moment(regularlyReservation.start_datetime).format(
                  "hh:mm"
                )
              }}
            </span>
            <span>～</span>
            <date-picker
              v-if="isEdit"
              v-model="regularlyReservation.timeEnd"
              lang="ja"
              type="time"
              placeholder="hh:mm"
              format="hh:mm"
              value-type="format"
            ></date-picker>
            <span v-else>
              {{
                this.$moment(regularlyReservation.end_datetime).format("hh:mm")
              }}
            </span>
          </div>
        </div>
        <div>
          <div class="mt-2">
            <b-form-radio-group
              :disabled="!isEdit"
              v-if="
                regularlyReservation.work_reservation &&
                  regularlyReservation.work_reservation
                    .zz_regularly_reservation_interval
              "
              v-model="
                regularlyReservation.work_reservation
                  .zz_regularly_reservation_interval.id
              "
              class="d-inline-flex align-items-center"
            >
              <b-form-radio
                v-for="item in zz_regularly_reservation_intervals"
                :key="item.id"
                :value="item.id"
                class="me-4"
              >
                {{ item.regularly_reservation_interval }}
                <span
                  v-if="
                    regularlyReservation.work_reservation
                      .regularly_reservation_date_of_month &&
                      item.regularly_reservation_interval == '毎月'
                  "
                  class="ms-1 d-inline-flex align-items-center"
                >
                  <b-form-input v-if="isEdit" min="0" max="31" />
                  <span v-else>
                    {{
                      regularlyReservation.work_reservation
                        .regularly_reservation_date_of_month
                    }} </span
                  >日
                </span>
              </b-form-radio>
            </b-form-radio-group>
            <b-form-radio-group
              :disabled="!isEdit"
              v-else
              class="d-inline-flex align-items-center"
            >
              <b-form-radio
                v-for="item in zz_regularly_reservation_intervals"
                :key="item.id"
                :value="item.id"
                class="me-4"
              >
                {{ item.regularly_reservation_interval }}
                <span
                  v-if="item.regularly_reservation_interval == '毎月'"
                  class="ms-1 d-inline-flex align-items-center"
                >
                  <b-form-input v-if="isEdit" min="0" max="31" />日
                </span>
              </b-form-radio>
            </b-form-radio-group>
          </div>
          <div class="mt-1">
            <b-form-checkbox-group
              :disabled="!isEdit"
              v-if="regularlyReservation.work_reservation"
              v-model="
                regularlyReservation.work_reservation
                  .regularly_reservation_day_of_week
              "
              class="d-inline-flex gap-4"
            >
              <b-form-checkbox
                v-for="(item, index) in days_of_the_week"
                :key="index"
                :value="item.value"
              >
                {{ item.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2">
      <b-button :disabled="!isEdit" variant="primary" class="w-100"
        >車両を選択する</b-button
      >
    </div>
    <div class="mb-2 d-flex w-100 gap-2 flex-wrap">
      <h4
        v-for="item in regularlyReservation.assigned_cars_by_schedule"
        :key="item.id"
      >
        <span class="badge bg-info">
          {{ item.zz_car_type.car_type }} {{ item.area_name }}-{{
            item.overall_height
          }}-{{ item.hiragana }}
          <span
            v-if="isEdit"
            class="ms-2 rounded-circle bg-white btn-delete"
            @click="removeCarBySchedule(regularlyReservation.id)"
            >×</span
          >
        </span>
      </h4>
    </div>
    <div class="mb-2">
      <b-button :disabled="!isEdit" variant="primary" class="w-100"
        >作業者を選択する</b-button
      >
    </div>
    <div class="mb-2 d-flex w-100 gap-2 flex-wrap">
      <h4
        v-for="item in regularlyReservation.assigned_staffs_by_schedule"
        :key="item.id"
      >
        <span class="badge bg-info"
          >{{ item.user_name }}
          <span
            v-if="isEdit"
            class="ms-2 rounded-circle bg-white btn-delete"
            @click="removeStaffBySchedule(regularlyReservation.id)"
            >×</span
          >
        </span>
      </h4>
    </div>
    <div class="mb-4">
      <b-form-radio-group
        :disabled="!isEdit"
        class="d-inline-flex"
        v-if="regularlyReservation.zz_reservation_status2"
        v-model="regularlyReservation.zz_reservation_status2.id"
      >
        <b-form-radio
          v-for="item in zz_reservation_status_2"
          :key="item.id"
          :value="item.id"
          class="me-4"
        >
          {{ item.reservation_status_2 }}
        </b-form-radio>
      </b-form-radio-group>
      <div class="d-flex col-gap-5">
        <div class="d-inline-flex">
          <span class="lbl-custom">合積：</span>
          <b-form-checkbox
            :disabled="!isEdit"
            :checked="regularlyReservation.is_mixed_loading_kbn == 1"
            class="ms-2"
          />
          <span class="ms-1">あり</span>
        </div>
        <div class="d-inline-flex ">
          <span class="lbl-custom">合積受付番号：</span>
          <b-form-input
            v-if="isEdit"
            class="w-25"
            v-model="regularlyReservation.schedule_id_of_mixed_loading"
          />
          <span v-else class="ms-1">
            {{ regularlyReservation.schedule_id_of_mixed_loading }}
          </span>
        </div>
      </div>
    </div>
    <div class="mb-3 title-detail">■作業内容</div>
    <div
      class="mb-3"
      v-for="(item,
      index) in regularlyReservation.waste_or_services_by_schedule"
      :key="item.id"
    >
      <div class="mb-2">
        <span>{{ index + 1 }}.</span>
        <span class="ms-1 lbl-custom">廃棄物・サービス名：</span
        ><span>{{
          getNameWasteOrServiceByWorkOrder(item.waste_or_service_by_work_order)
        }}</span>
        <span class="ms-5 lbl-custom">廃棄物種類：</span
        ><span>{{
          getNameCategoryWasteOrServiceByWorkOrder(item.waste_or_service_by_work_order)
        }}</span>
        <span class="ms-5 lbl-custom">マニフェスト：</span
        ><span v-if="item.number_of_manifest"
          >{{ item.number_of_manifest }} 枚</span
        >
      </div>
      <div class="mb-2 d-flex">
        <span class="lbl-custom">運搬先・処分方法：</span>
        <span class="ms-1">
          <b-form-input
            v-if="isEdit"
            :value=" getVendorSiteOfTreatmentNameMethod(item.waste_or_service_by_work_order.disposal_site) "
            type="text"
          />
          <span v-else>
            {{
              getVendorSiteOfTreatmentNameMethod(item.waste_or_service_by_work_order.disposal_site)
            }}
          </span>
        </span>
        <span class="ms-4">
          <b-button
            :disabled="!isEdit"
            variant="primary"
            @click="updateTransport(item.cd)"
            >変更</b-button
          >
        </span>
      </div>
      <CommonTableComponent :height-class="`table-wrapper-500`">
        <thead class="table-light">
          <tr>
            <th>見積明細番号</th>
            <th>請求書表示用商品名</th>
            <th>予定数量</th>
            <th>単位</th>
            <th>空容器数量（事前申込済のみ）</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item1 in item.waste_estimates_by_schedule" :key="item1.id">
            <td>{{ item1.estimate_cd }}</td>
            <td>{{ item1.invoice_product_name }}</td>
            <td>
              <ValidationProvider
                rules="required"
                :custom-messages="{ required: '予定数量は必須項目です' }"
                v-slot="{ errors, classes }"
              >
                <div class="input-control" :class="classes">
                  <b-form-input
                    type="number"
                    v-model="item1.pivot.quantity"
                    min="0"
                  />
                  <span>{{ errors[0] }}</span>
                </div>
              </ValidationProvider>
            </td>
            <td>{{ item1.zz_unit.unit }}</td>
            <td>
              <b-form-input
                type="text"
                v-model="item1.pivot.number_of_rental_containers"
                maxLength="50"
              />
            </td>
          </tr>
        </tbody>
      </CommonTableComponent>
    </div>
  </b-card>
</template>

<style scoped>
.lbl-custom {
  font-weight: 600;
}

.d-flex label {
  flex: 0 0 auto;
}

.title-detail {
  font-size: 16px;
  font-weight: 600;
}

.bg-white {
  background-color: #fff !important;
}

span.btn-delete {
  font-size: 13px;
  width: 18px;
  line-height: 18px;
  display: inline-block;
  cursor: pointer;
  color: #045e94;
  font-weight: bold;
  transition: opacity 0.15s ease-in-out;
}
span.btn-delete:hover {
  opacity: 0.8;
}
.col-gap-5 {
  column-gap: 5rem !important;
}
</style>
